import { render } from "./ShipyardsAdmin.vue?vue&type=template&id=31834328&scoped=true"
import script from "./ShipyardsAdmin.vue?vue&type=script&lang=ts"
export * from "./ShipyardsAdmin.vue?vue&type=script&lang=ts"

import "./ShipyardsAdmin.vue?vue&type=style&index=0&id=31834328&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31834328"

export default script